<template>
  <div
    v-if="isObject(group)"
    class="pt-3"
    :class="{
      'border-bottom': depth > 1 || localCollapsed,
      'pb-3': localCollapsed,
    }"
  >
    <div
      @click="localCollapsed = !localCollapsed"
      class="d-flex align-items-center justify-content-between pointer"
      :class="{ 'border-bottom': !localCollapsed, 'pb-3': !localCollapsed }"
    >
      <div class="mb-0" :class="depthFontSizeClass" :style="depthMarginStyle">
        {{ capitalize(sectionKey) }}
      </div>
      <span class="mx-1">
        <i
          class="fal fa-chevron-down rotate fa-fw"
          :class="{ down: !localCollapsed }"
        ></i>
      </span>
    </div>
    <template v-if="!localCollapsed">
      <TranslationCollapsableGroup
        v-for="(obj, key) in group"
        :key="calculateKey(key)"
        @input="updateTranslation"
        :collapsed="collapsed"
        :group="obj"
        :depth="depth + 1"
        :parentKey="calculateKey(key)"
      />
    </template>
  </div>
  <div v-else class="py-2 translation-input-container">
    <!-- endnode -->
    <div :style="depthMarginStyle">
      <div class="translation-input-header pb-3 pt-2">
        <div class="row py-1">
          <div class="col-md-4 d-flex align-items-center">
            <small>{{ $t('LABEL_EDITOR.LABEL.DEFAULT') }}</small>
          </div>
          <div class="col-md-8 d-flex align-items-center">
            <small>{{ $t('LABEL_EDITOR.LABEL.REPLACE_WITH') }}</small>
          </div>
        </div>
      </div>
      <TranslationInput
        v-if="!isPluralizationTranslation"
        @input="updateTranslation"
        :translationKey="parentKey"
        :translationText="group"
      />
      <TranslationPluralizationInputGroup
        v-if="isPluralizationTranslation"
        @input="updateTranslation"
        :translationKey="parentKey"
        :translationText="group"
      />
    </div>
  </div>
</template>
<script>
import { isObject, capitalize } from 'lodash';
import TranslationInput from '@/web/components/settings/TranslationInput.vue';
import TranslationPluralizationInputGroup from '@/web/components/settings/TranslationPluralizationInputGroup';

export default {
  name: 'TranslationCollapsableGroup',
  components: {
    TranslationInput,
    TranslationPluralizationInputGroup,
  },
  props: {
    group: {
      type: [Object, String],
    },
    depth: {
      type: Number,
      default: 1,
    },
    collapsed: {
      type: Boolean,
      default: true,
    },
    parentKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    depthFontSizeClass() {
      return `h${this.depth + 1}${!this.localCollapsed ? ' c-coral' : ''}`;
    },
    depthMarginStyle() {
      return {
        marginLeft: `${(this.depth - 1) * 0.75}rem`,
      };
    },
    sectionKey() {
      const sections = this.parentKey.split('.');
      const sectionLabel = sections.pop();
      return sectionLabel.replace('_', ' ');
    },
    isPluralizationTranslation() {
      return !isObject(this.group) && this.group.split(/\s?[|]\s?/).length > 1;
    },
  },
  data() {
    return {
      localCollapsed: this.collapsed,
    };
  },
  methods: {
    isObject,
    updateTranslation({ translationText, translationKey }) {
      this.$emit('input', { translationText, translationKey });
    },
    calculateKey(key) {
      if (!this.parentKey) {
        return key;
      }
      return `${this.parentKey}.${key}`;
    },
    capitalize,
  },
  watch: {
    collapsed: {
      handler(value) {
        this.localCollapsed = value;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.translation-input-header {
  display: none;
  overflow: hidden;
}
.translation-input-container:nth-child(2) {
  .translation-input-header {
    display: block !important;
  }
}
.translation-input-container:last-child {
  margin-bottom: 0.5rem;
}
</style>
